import { Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { LoadingOverlay } from "components/layout/LoadingOverlay";

// PRTL-1087: thin layout wrapper for the /private-events tree so the calendar
// (index child) and the Zoom join screen (/$id/join child) can render
// independently. Mirrors EventsLayout — kept separate so the two trees can
// diverge without affecting each other.
export const CompassEventsLayout = () => {
    return (
        <Suspense fallback={<LoadingOverlay />}>
            <Outlet />
        </Suspense>
    );
};
